module.exports = "<div class=\"sidebar-header\">\n  <img src=\"assets/img/avatars/cryosoft.png\" class=\"img-avatar\" alt=\"Avatar\">\n  <div><strong>{{'CRYOSOFT'|translate}}</strong></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/components/app-sidebar-header/app-sidebar-header.component.html
// module id = ../../../../../src/app/components/app-sidebar-header/app-sidebar-header.component.html
// module chunks = main